<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="Prompt_Prompt-Heading">Week 1: Create a<span class="noBreak"> </span><span class="noBreak">Timeline.</span></p>
<div class="frame2">
<p class="Prompt_Prompt-copy">For this exercise you’ll be asked to create a visual timeline that illustrates all the most significant moments of your life. An illustrated timeline is useful because it gives you a clear progression of your life in pictures. You can easily look at this visual and see how you’ve grown as<span class="noBreak"> a</span><span class="noBreak"> </span><span class="noBreak">person.</span></p>
<p class="Prompt_Prompt-copy">First, think of all the most significant moments in your life and write them down on a timeline that starts with your first memory, like starting school, moving, making a friend, or having an experience with an influential person in your life. Draw the memory as you remember it happening or pick an image from the memory and draw that. Continue with the rest of your timeline, drawing the most important or special moments to you, until you have a visual representation of your life laid out in images. You may want to use art paper for this exercise or oversized poster board so you have enough room to draw out the memories. You can also project into the future by drawing a future timeline with images of what you hope to achieve in the years to come. This is an activity you can do in one sitting or as memories come back to you. It’s up to you to decide how long you want to spend on it, but it’s probably a good idea to plan at least an hour for your first session of drawing<span class="noBreak"> </span><span class="noBreak">memories.</span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// BlackAndResilient7.vue?6b3e1c87